import { StateCreator } from "zustand";
import type { Invitation, ClaimedVia } from "./invitation.types";

// --- State Type ---
export type InvitationSliceState = {
  invitation: Invitation | null;
  claimedVia: ClaimedVia | null;
};

// --- Actions Type ---
export type InvitationSliceActions = {
  setInvitation: (
    invitation: Invitation | null,
    claimedVia?: ClaimedVia
  ) => void;
};

// --- Combined Type ---
export type InvitationSlice = InvitationSliceState & InvitationSliceActions;

// --- Initial State ---
export const initialInvitationState: InvitationSliceState = {
  invitation: null,
  claimedVia: null,
};

// --- Slice Creator ---
export const createInvitationSlice: StateCreator<
  InvitationSlice,
  [],
  [],
  InvitationSlice
> = (set) => ({
  ...initialInvitationState,

  setInvitation: (invitation, claimedVia) =>
    set({
      invitation,
      claimedVia: claimedVia ?? null,
    }),
});

// --- Selectors ---
export const invitation = {
  state: (s: InvitationSlice) => ({
    invitation: s.invitation,
    claimedVia: s.claimedVia,
    setInvitation: s.setInvitation,
  }),
};
